export interface ActivityType {
    id: number;
    name: string;
}

export class ActivityTypes {
    public static readonly None: ActivityType = { id: 0, name: "None" };
    public static readonly Survey: ActivityType = { id: 1, name: "Survey" };
    public static readonly Quiz: ActivityType = { id: 2, name: "Quiz" };

    public static All: ActivityType[] = [
        ActivityTypes.Survey,
        ActivityTypes.Quiz,
    ];

    public static FindById(id: number) {
        return this.All.find(x => x.id === id) || this.None;
    }
}



// WEBPACK FOOTER //
// ./src/constants/ActivityType.ts